module.exports = __webpack_public_path__ + "static/media/bgTotalGroup.8085cb75.png";